@if (isEdit) {
  <h2 mat-dialog-title>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.EDIT_TITLE' | translate }}</h2>
} @else {
  <h2 mat-dialog-title>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.TITLE' | translate }}</h2>
}

<mat-dialog-content>
  <p class="intro">{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.INTRO' | translate }}</p>

  <form [formGroup]="form">
    <glxy-form-field required="true">
      <glxy-label>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.NAME_LABEL' | translate }}</glxy-label>
      <input
        type="text"
        matInput
        formControlName="name"
        [placeholder]="'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.NAME_PLACEHOLDER' | translate"
      />
      @if (form.controls.name.touched && form.controls.name.hasError('required')) {
        <glxy-error>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.NAME_REQUIRED' | translate }}</glxy-error>
      }
    </glxy-form-field>

    <glxy-form-field required="true">
      <glxy-label>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.SCENARIO_LABEL' | translate }}</glxy-label>
      <glxy-hint>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.SCENARIO_HINT' | translate }}</glxy-hint>
      <glxy-hint align="end">{{ form.controls.scenario.value.length }}/{{ maxScenarioLength }}</glxy-hint>
      <textarea
        rows="2"
        matInput
        [attr.maxlength]="maxScenarioLength"
        formControlName="scenario"
        [placeholder]="'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.SCENARIO_PLACEHOLDER' | translate"
      ></textarea>
      @if (form.controls.scenario.touched && form.controls.scenario.hasError('required')) {
        <glxy-error>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.SCENARIO_REQUIRED' | translate }}</glxy-error>
      } @else if (form.controls.scenario.hasError('maxlength')) {
        <glxy-error>{{
          'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.SCENARIO_TOO_LONG' | translate: { max: maxScenarioLength }
        }}</glxy-error>
      }
    </glxy-form-field>

    <glxy-form-field required="true">
      <glxy-label>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.EXPECTATION_LABEL' | translate }}</glxy-label>
      <glxy-hint>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.EXPECTATION_HINT' | translate }}</glxy-hint>
      <textarea
        rows="3"
        matInput
        formControlName="expectation"
        [placeholder]="'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.EXPECTATION_PLACEHOLDER' | translate"
      ></textarea>
      @if (form.controls.expectation.touched && form.controls.expectation.hasError('required')) {
        <glxy-error>{{
          'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.EXPECTATION_REQUIRED' | translate
        }}</glxy-error>
      }
    </glxy-form-field>

    <glxy-form-field required="true" [suffixText]="'%'">
      <glxy-label>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.TARGET_LABEL' | translate }}</glxy-label>
      @if (!targetErrorShown()) {
        <glxy-hint>
          {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.TARGET_HINT' | translate }}
          @if (isEdit) {
            <br />
            @if (successRate !== null) {
              {{
                'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.TARGET_CURRENT_RATE'
                  | translate
                    : {
                        passed: passedCount | number,
                        evaluated: evaluatedCount | number,
                        rate: successRate | percent: '1.0-1',
                        days: evaluationWindowDays,
                      }
              }}
            } @else {
              {{
                'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.TARGET_NOT_SCORED'
                  | translate: { days: evaluationWindowDays }
              }}
            }
          }
        </glxy-hint>
      }
      <input
        type="number"
        matInput
        step="1"
        formControlName="targetPercent"
        [min]="minTargetPercent"
        [max]="maxTargetPercent"
      />
      @if (form.controls.targetPercent.touched && form.controls.targetPercent.hasError('required')) {
        <glxy-error>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.TARGET_REQUIRED' | translate }}</glxy-error>
      } @else if (form.controls.targetPercent.hasError('min') || form.controls.targetPercent.hasError('max')) {
        <glxy-error>{{
          'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.TARGET_OUT_OF_RANGE'
            | translate: { min: minTargetPercent, max: maxTargetPercent }
        }}</glxy-error>
      } @else if (form.controls.targetPercent.hasError('wholeNumber')) {
        <glxy-error>{{
          'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.TARGET_WHOLE_NUMBER' | translate
        }}</glxy-error>
      }
    </glxy-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button type="button" (click)="cancel()">
    {{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" type="button" [disabled]="form.invalid" (click)="submit()">
    @if (isEdit) {
      {{ 'AI_ASSISTANT.SHARED.SAVE' | translate }}
    } @else {
      {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CREATE_MODAL.SUBMIT' | translate }}
    }
  </button>
</mat-dialog-actions>
